import style from "./PathDetails.module.css";
import { useTranslation } from "react-i18next";
import Icon from "@/ui/icon/Icon";
import Button from "@/ui/button/Button";
import { secondsToHoursMinutes } from "@/utils/helpers";

import PathScheduleTestPopup from "@/features/paths/components/pathScheduleTestPopup/PathScheduleTestPopup";

import { padZero } from "@/utils/helpers";

import { useContext } from "react";
import PathPreviewContext from "../../contexts/PathPreviewContext";
import { useNavigate } from "react-router-dom";
import { successToast, warningToast } from "@/ui/toast/Toast";
import { useUser } from "@/features/auth/hooks/useUser";
import PathScheduleAppointment from "../pathScheduleAppointment/PathScheduleAppointment";

function PathDetails() {
	const { t } = useTranslation();
	const { path } = useContext(PathPreviewContext);
	const { user } = useUser();
	const navigate = useNavigate();

	const details = [
		{
			id: 3,
			icon: "fa-fingerprint",
			label: t("paths:details.certificateCount"),
			value: path.certificate_id,
		},
		{
			id: 1,
			icon: "fa-layer-group",
			label: t("paths:stats.moduleCount"),
			value: padZero(path.module_count),
		},
		{
			id: 2,
			icon: "fa-question",
			label: t("courses:landing.details.quizzes"),
			value: padZero(path.quiz_count),
		},
		{
			id: 4,
			icon: "fa-user",
			label: t("courses:landing.details.lecturers"),
			value: padZero(path.lecturers.length),
		},
		{
			id: 6,
			icon: "fa-star",
			label: t("courses:landing.details.reviews"),
			value: path.rating,
		},

		// {
		// 	id: 5,
		// 	icon: "fa-align-left",
		// 	label: "Silabus",
		// 	value: "Preuzmi silabus",
		// 	downloadable: true,
		// },

		// {
		// 	id: 7,
		// 	icon: "fa-file",
		// 	label: "Projekti",
		// 	value: "Preuzmi projekat",
		// 	downloadable: true,
		// },
	];

	return (
		<div className={style.pathDetails}>
			<div className={style.pointsHolder}>
				<span className={style.label}>
					{path.ects_credits != 0
						? t("paths:details.earns")
						: t("paths:details.consistsOf")}
				</span>
				{path.ects_credits != 0 && (
					<div className={style.points}>
						<span className={style.value}>{path.ects_credits}</span>
						<span className={style.valute}>
							<span>ECTS</span>
							<span>{t("paths:ects.points")}</span>
						</span>
					</div>
				)}
			</div>
			<div className={style.infoHolder}>
				<div className={style.item}>
					<div className={style.icoHolder}>
						<Icon icon="fa-chalkboard" />
					</div>
					<div className={style.content}>
						<div className={style.label}>
							{t("paths:details.courses")}
						</div>
						<div className={style.value}>{path.course_count}</div>
					</div>
				</div>
				<div className={style.item}>
					<div className={style.icoHolder}>
						<Icon icon="fa-clock" />
					</div>
					<div className={style.content}>
						<div className={style.label}>
							{t("courses:landing.sidebar.duration")}
						</div>
						<div className={style.value}>
							{secondsToHoursMinutes(path.duration)}
						</div>
					</div>
				</div>
			</div>
			<div className={style.details}>
				{details.map((detail) => (
					<div key={detail.id} className={style.detail}>
						<div className={style.icoHolder}>
							<Icon icon={detail.icon} />
						</div>
						<div className={style.label}>{detail.label}:</div>
						<div className={style.value}>
							{detail.downloadable ? (
								<div className={style.downloadable}>
									{detail.value}
								</div>
							) : (
								detail.value
							)}
						</div>
					</div>
				))}
			</div>
			<div className={style.buttonsHolder}>
				<Button
					type="accent"
					onClick={() => {
						if (!user || !user?.is_subscribed) {
							warningToast(t("paths:details.subscribeFirst"));
							navigate("/plans");
							return;
						}
						if (!path.courses.length) return;
						navigate(`/courses/${path.courses[0].slug}`);
						successToast(t("paths:details.started"));
					}}
				>
					<span>{t("paths:details.start")}</span>{" "}
					<Icon icon="fa-arrow-right" iconType="fa-solid" />
				</Button>
				{path.ects_credits != 0 && <PathScheduleAppointment />}
			</div>
		</div>
	);
}

export default PathDetails;
